import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { EZIndexes } from '@/enums/EZIndexes';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { BUTTON__language_change } from '@/pages/_base/layout_header/_buttons/BUTTON__language_change';
import { REMOTE__collection_get_recent_images_urls } from '@/state/collection/cell/REMOTE__collection_get_recent_images_urls';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { useMemo, useState } from 'react';
import { DROPDOWN__help } from '../layout_footer/dropdown_help/DROPDOWN__help';

interface Props {
  children: React.ReactNode;
}

export function LAYOUT_PAGE__recent_images_grid({ children }: Props) {
  const dispatch = use_dispatch();
  const [urls, set_urls] = useState<string[]>([]);

  const urls_to_render = useMemo(() => get_urls_to_render(), [urls]);
  const columns_data = useMemo(() => get_columns_data(), [urls_to_render]);

  /*
   * EFFECTS
   */
  use_effect(() => void load());

  /*
   * METHODS
   */

  async function load() {
    let action_result = await dispatch(REMOTE__collection_get_recent_images_urls());

    let response = action_result.payload;

    if (!Array.isArray(response)) return;

    response = response.map(url => path_relative_to_absolute(url));

    set_urls(response);
  }

  function get_urls_to_render(): string[] {
    if (urls.length === 0) return [];

    const out: string[] = [];

    for (let i = 0; i < CONSTANTS__shared.IMAGES_ON_LOADER_SCREEN; i++) {
      out.push(urls[i % urls.length]);
    }

    return out;
  }

  function get_columns_data(): string[][] {
    const out = Array.from({ length: CONSTANTS__client.AUTH_GRID_COLUMNS_COUNT }, () => [] as string[]);

    for (const [i, url] of urls_to_render.entries()) {
      const columnIndex = i % CONSTANTS__client.AUTH_GRID_COLUMNS_COUNT;
      out[columnIndex].push(url);
    }

    return out;
  }

  /*
   * RENDERS
   */

  function render_column(urlsInColumn: string[]) {
    return urlsInColumn.map((url, index) => (
      <div key={`image_${index}`} className="overflow-hidden group relative">
        <img
          draggable={false}
          onDragStart={e => e.preventDefault()}
          onContextMenu={e => e.preventDefault()}
          src={url}
          alt=""
          style={{ userSelect: 'none' }}
          className="
            block w-full h-auto
            blur
            transition-all duration-1000
            group-hover:blur-0
            group-hover:scale-105
          "
        />

        <div
          className="
            absolute inset-0
            bg-black bg-opacity-80
            transition-all duration-1000
            group-hover:bg-opacity-0
          "
        />
      </div>
    ));
  }

  function render_grid() {
    return columns_data.map((urlsInColumn: string[], index: number) => (
      <div key={`column_${index}`} className="flex flex-col" style={{ width: `${CONSTANTS__client.AUTH_GRID_COLUMN_WIDTH}px` }}>
        {render_column(urlsInColumn)}
      </div>
    ));
  }

  /*
   * HTML
   */

  return (
    <div className="relative w-screen h-screen overflow-visible bg-bar">
      <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${EZIndexes.AUTH_MAIN}`}>{children}</div>

      <BUTTON__language_change
        button_wrapper_class_name={`fixed ${EZIndexes.BUTTON_CHANGE_LANGUAGE} bottom-1 right-1 bg-bar flex justify-between  px-2 py-1 rounded-lg border border-component-border`}
      />

      <div
        className={`fixed ${EZIndexes.AUTH_BUTTON_HELP} bottom-2 left-2 bg-bar  p-1.5 rounded-lg flex items-center justify-center border border-component-border`}
      >
        <DROPDOWN__help />
      </div>

      <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex  ${EZIndexes.AUTH_BACKGROUND}`}>{render_grid()}</div>
    </div>
  );
}
